import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
import Button from '../Button';
import styles from './FilterStandardActions.module.css';
const FilterStandardActions = ({ className, applyAction, cancelAction, }) => {
    return (_jsxs("div", Object.assign({ className: classNames(className, styles.root) }, { children: [_jsx(Button, Object.assign({ size: "small", variant: "text", onClick: cancelAction }, { children: "Cancel" }), void 0), _jsx(Button, Object.assign({ size: "small", onClick: applyAction }, { children: "Apply" }), void 0)] }), void 0));
};
export default FilterStandardActions;
